import { decodeObjPathName, getFilePathFromObjectPath, getPropertyDisplayValue } from "utils/objectData";

export function getPropertiesStampHeading(name: string): string {
    return decodeObjPathName(name);
}

/** Path values show the file name in the cell, so the tooltip carries the decoded file path. */
export function getPropertiesStampValueTooltip(key: string, value: string): string {
    if (key.toLowerCase() === "path") {
        return decodeObjPathName(getFilePathFromObjectPath(value) ?? value);
    }

    return getPropertyDisplayValue(value);
}
